// Consent Mode signals mapped from OneTrust categories (C0002 performance,
// C0003 functional, C0004 targeting). Mirrors hingehealth-website.
const CONSENT_SIGNALS = `{analytics_storage:v('C0002'),functionality_storage:v('C0003'),personalization_storage:v('C0003'),ad_storage:v('C0004'),ad_user_data:v('C0004'),ad_personalization:v('C0004')}`;

// GTM bootstrap for the SSR <head>. Consent defaults come from the stored
// OneTrust cookie, so returning visitors aren't treated as denied while the
// OneTrust SDK is still loading at idle; everyone else starts denied.
export const buildGtmHeadScript = (id: string) =>
  `(function(w,d,s,l,i){` +
  `w[l]=w[l]||[];` +
  `function gtag(){w[l].push(arguments);}` +
  `var g='';try{var m=d.cookie.match(/(?:^|; )OptanonConsent=([^;]*)/);` +
  `if(m){g=(decodeURIComponent(m[1]).match(/groups=([^&]*)/)||[])[1]||'';}}catch(e){}` +
  `function v(c){return g.indexOf(c+':1')!==-1?'granted':'denied';}` +
  `var c=${CONSENT_SIGNALS};c.security_storage='granted';c.wait_for_update=500;` +
  `gtag('consent','default',c);` +
  `w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js','platform':'aws'});` +
  `var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;` +
  `j.src='https://www.googletagmanager.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);` +
  `})(window,document,'script','dataLayer',${JSON.stringify(id)});`;

// Defines updateGoogleConsent() inside the idle loader's IIFE (needs `w` in
// scope). Called from OptanonWrapper on load and on every consent change.
export const GOOGLE_CONSENT_UPDATE_JS = `
  function updateGoogleConsent(){
    var g = typeof w.OnetrustActiveGroups !== 'undefined' ? w.OnetrustActiveGroups : '';
    function v(c){ return g.indexOf(c) !== -1 ? 'granted' : 'denied'; }
    w.dataLayer = w.dataLayer || [];
    (function(){ w.dataLayer.push(arguments); })('consent', 'update', ${CONSENT_SIGNALS});
  }`;
